import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Route, Router } from '@angular/router';
import { AppRoutes } from 'src/app/app.routes';
import { AuthService } from 'src/app/public/auth/auth.service';
import { PublicRoutes } from 'src/app/public/public.routes';
import { SessionService } from 'src/app/shared/services/sessionStorage.service';
import { Images } from 'src/assets/data/images';
import { AdminRoutes } from '../../admin.routes';
import { Subscription } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';
import Swal from 'sweetalert2';
import { MenuService } from 'src/app/_core/services/menu.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  
  public userOne: string = Images.users.userOne;
  
  isProfileOpen: boolean = false; // Variable pour suivre l'état du menu déroulant
  currentTab: string = '';
  menuTitle: string = '';
  currentUser: any;
  itemsPerPage: any;
  currentPage: any;
  itemToSave: any;
  busyGet!: Subscription;

  hidePassword = true;
  hideNewPassword = true;
  submitted = false;
  changePassword!: FormGroup;
  showPasswordModal: boolean = false;
  itemsClient: any[] = [];

  itemToSearch: any = {};
  isOpen = false;
  totalItems: any;
  isLoading: boolean = false;
  
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private menuService: MenuService,
    private authService: AuthService,

          private fb: FormBuilder,
          private utilities: UtilitiesService,
    private router: Router,
    private localStorageService: SessionService,
  ) {}

  onTabClick(tabName: string) {
    this.currentTab = tabName;
  }

  onDeconnected() {
    this.authService.logout().subscribe({
      next: () => {
        console.log('Déconnexion réussie');
        this.router.navigate([PublicRoutes.Signin]);
      },
      error: (err) => {
        console.error('Erreur lors de la déconnexion', err);
      },
    });
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
  toggleNewPasswordVisibility(): void {
    this.hideNewPassword= !this.hideNewPassword;
  }

  protected onOtpSubmitHandler = (event: MouseEvent) => {
    const accessToken: string = this.localStorageService.get('token');
    event.preventDefault();
    this.isLoading = true;

    setTimeout(() => {
      this.isLoading = false;
      this.router.navigate(['admin/settings/users']);
    }, 1000);
  };

  toggleProfile(event: Event) {
    event.stopPropagation(); 
    this.isProfileOpen = !this.isProfileOpen;
    console.log('Menu ouvert:', this.isProfileOpen); 
  }
  
  // Ferme le menu si on clique en dehors
  @HostListener('document:click')
  clickOutside() {
    if (this.isProfileOpen) {
      this.isProfileOpen = false;
    }
  }

  ngOnInit() {
    this.currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );

    this.initPasswordForm();

    // console.log('currenUser',this.currentUser)

    this.menuService.menuTitle$.subscribe((title: any) => {
      this.menuTitle = title;
    });
  }
  closePasswordModal() {
    this.showPasswordModal = false;
  }

    initPasswordForm(): void {
      this.changePassword = this.fb.group({
        email: [this.currentUser?.email || '', Validators.required, ],
        oldMotDePasse: ['', Validators.required],
        motDePasse: ['', [Validators.required, ]]
      });
      //Validators.minLength(8)
    }

  openChangePasswordModal(): void {
    this.changePassword.reset({
      email: this.currentUser?.email || ''
    });
    this.submitted = false;
    this.showPasswordModal = true;
  }

   get changePasswordControls(): { [key: string]: AbstractControl } {
        return this.changePassword ? this.changePassword.controls : {};
      }
    
      hasError(controlName: string, errorType: string): boolean {
        const control = this.changePasswordControls[controlName];
        return control ? this.submitted && control.hasError(errorType) : false;
      }

      confirmSave(): void {
            this.submitted = true;
            
            if (this.changePassword.invalid) {
              this.utilities.showNotification(
                "Veuillez saisir tous les champs ",
                'error'
              );
              return;
            }
        
            // Swal.fire({
            //   title: 'Confirmation',
            //   text: 'Voulez-vous vraiment modifier votre mot de passe ?',
            //   icon: 'warning',
            //   showCancelButton: true,
            //   confirmButtonColor: '#ff7900',
            //   cancelButtonColor: '#d33',
            //   confirmButtonText: 'Oui',
            //   cancelButtonText: 'Non',
            // }).then((result) => {
            //   if (result.isConfirmed) {
            //     this.changeMotPasse();
            //   }
            // });
            this.changeMotPasse();
          }

          changeMotPasse(): void {
            const payload = {
              email: this.changePassword.value.email,
              oldPassword: this.changePassword.value.oldMotDePasse,
              newPassword: this.changePassword.value.motDePasse
            };
          
            this.authService.changePassWord(payload.email, payload.newPassword, payload.oldPassword)
              .subscribe({
                next: (res) => {
                  if (res && !res['hasError']) {
                    this.utilities.showNotification(
                      'Mot de passe modifié avec succès',
                      'success'
                    );
                    this.closePasswordModal();
                  } else {
                    this.utilities.showNotification(
                      res['status']?.message || 'Échec de la modification du mot de passe',
                      'error'
                    );
                  }
                 
                },
                error: (err) => {
                  console.error('Erreur:', err);
                  this.utilities.showNotification(
                    err.error?.message || 'Une erreur est survenue',
                    'error'
                  );
                }
              });
          }
      
          // saveItem() {
            
          //   if (this.changePassword.invalid) {
          //     this.utilities.showNotification(
          //       'Veuillez corriger les erreurs du formulaire',
          //       'error'
          //     );
          //     return;
          //   }
        
          //   const email = this.changePassword.get('email')?.value;
      
          //   const { codeOtp, motDePasse } = this.changePassword.value;
        
          //   this.authService
          //     .changeMotDePasse(email, motDePasse, codeOtp)
          //     .subscribe({
          //       next: (res: any) => {
          //         if (res && !res['hasError']) {
          //           this.utilities.showNotification(
          //             'Mot de passe modifié avec succès',
          //             'success'
          //           );
          //           this.closePasswordModal();
          //           this.router.navigate([PublicRoutes.Signin]);
          //         } else {
          //           this.utilities.showNotification(
          //             res['status']?.message ||
          //               'Échec de la modification du mot de passe',
          //             'error'
          //           );
          //         }
          //       },
          //       error: (error) => {
          //         console.error('Erreur lors du changement de mot de passe:', error);
          //         this.utilities.showNotification(
          //           'Une erreur est survenue lors du changement de mot de passe',
          //           'error'
          //         );
          //       },
          //     });
          // }

          toggleProfil() {
            const profileDropdownList = this.element.nativeElement.querySelector(
              '.profile-dropdown-list'
            );
            
            // Récupérer l'état actuel
            const isExpanded = profileDropdownList.getAttribute('aria-expanded') === 'true';
            
            // Basculer l'état (si ouvert, alors fermer et vice versa)
            this.renderer.setAttribute(
              profileDropdownList, 
              'aria-expanded', 
              isExpanded ? 'false' : 'true'
            );
            
            // Ajouter/supprimer une classe pour contrôler la visibilité par CSS
            if (isExpanded) {
              this.renderer.addClass(profileDropdownList, 'hidden');
            } else {
              this.renderer.removeClass(profileDropdownList, 'hidden');
            }
          }

}
